export interface ModalConfig {
  id?: string;
  visible?: boolean;
  title?: string | null;
  variant?: 'default' | 'error' | 'success' | 'warning'; //Affects header icon and header class. 'default' shows no special styling
  ariaLabelledBy?: string; //Default kept for compatibility with previous static markup which used "staticBackdropLabel"
  size?: 'sm' | 'md' | 'lg';
  /**
   * Optional overrides to provide a custom icon from the parent template.
   * If provided, `headerIconSrc` will be used instead of the variant-derived icon.
   */
  headerIconSrc?: string | null;
  headerIconAltOverride?: string | null;
  data?: any;
  hiddenCloseIcon?: boolean;
}

export const DEFAULT_MODAL_CONFIG: ModalConfig = {
  id: '',
  hiddenCloseIcon: false,
  visible: false,
  title: null,
  variant: 'default',
  ariaLabelledBy: 'staticBackdropLabel',
  size: 'md',
  headerIconSrc: null,
  headerIconAltOverride: null,
  data: null,
}